import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, CanLoad, Route, Router, CanActivateChild } from '@angular/router';
import { ConfigService } from '../Services/ConfigService';
import { PersonRoleEnum } from '../Models/OtherClasses';
import { EmployeeAuthGuard } from './EmployeeAuthGuard';

@Injectable()
export class HREmployeeAuthGuard extends EmployeeAuthGuard implements CanActivateChild {

	constructor(public configData: ConfigService, protected router: Router) {
		super(configData, router);
	}

	canLoad(route: Route) {
		return this.redirectIfNeeded((this.configData.isHRCompany || this.configData.isMasterCompany) && super.canLoad(route));
	}

	canActivateChild(route: ActivatedRouteSnapshot): boolean {
		return this.canActivate(route);
	}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		return this.redirectIfNeeded((this.configData.isHRCompany || this.configData.isMasterCompany) && super.canActivate(route));
	}

	redirectIfNeeded(isOk: boolean) {
		if (isOk) {
			return true;
		} else {
			this.router.navigate(['ang/Payment/NoHR']);
			return false;
		}
	}
}